import { clearingApi } from "../../config/apiConfig";

export const getAllBills = async ({ year, month } = {}) => {
  try {
    const response = await clearingApi.post(`bills/all`, { year, month });
    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const resumeAllBills = async ({ year, month } = {}) => {
  try {
    const response = await clearingApi.post(`bills/all/resume`, null, {
      params: { year, month },
    });
    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};
export const getEmpBills = async ({ mandateName }) => {
  const response = await clearingApi.get(
    `bills?mandant_name=${mandateName}`
  );
  return response.data;
};

export const finalizeDocument = async (documentId) => {
  const response = await clearingApi.post(`documents/finalize/${documentId}`);
  return response.data;
};

export const getBillsByDate = async ({ mandateName, year, month }) => {
  try {
    const response = await clearingApi.post(
      `bills?mandant_name=${mandateName}&year=${year}&month=${month}`
    );
    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};
